import axios from 'axios';
import { url } from './url'; // Make sure this import is correct

export const submitDemoRequest = async (payload: {
  name: string;
 email: string[]; // ✅ array of recipients
  userEmail: string; // user's own email for email body
  phone: string;
  company: string;
  requirement: string;
  selectedOptions: string[];
}) => {
  return axios.post(`${url.apiUrl}send-form-data-email`, payload);
};
